<template>
  <VSnackbar v-model="toastVisible" timeout="3000">
    {{ toastMessage }}
    <v-btn color="pink" @click="toastVisible = false">Close</v-btn>
  </VSnackbar>
</template>

<script lang="ts" src="./toast.ts"></script>
